import React from 'react'
import { Link } from 'react-router-dom'

export default function PageStart() {
  return (
    <nav>
        <ul>
            <li>
                <Link to ='/login/admin'>Login Admin</Link>
            </li>
            <li>
                <Link to ='/login/teacher'>Login Teacher</Link>
            </li>
            <li>
                <Link to ='/login/student'>Login Student</Link>
            </li>
            <li>
                <Link to ='/main/admin'>Main Admin</Link>
            </li>
            <li>
                <Link to ='/main/teacher'>Main Teacher</Link>
            </li>
            <li>
                <Link to ='/main/student'>Main Student</Link>
            </li>
            <li>
                <Link to ='/dataUpdate'>Data Update</Link>
            </li>

        </ul>
    </nav>
  )
}
